module.exports = __webpack_public_path__ + "assets/img/cloud3.cfb32b19.webp";